import { Component } from '@angular/core';
import { SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-settings-nurse-records',
    templateUrl: './service-settings-nurse-records.component.html',
    styleUrl: './service-settings-nurse-records.component.scss',
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingsNurseRecordsComponent {
    protected readonly SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY = SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY;
}
